import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './pages/Home/Home';
import Packages from './pages/Packages';
import NotFound from './pages/NotFound';
import AboutUs from './pages/About';
import ContactUs from './pages/Contact';

import NavBar from './components/NavBar';
import "./App.css";

function App() {

  const currentYear = new Date().getFullYear();

  return (
    <div className="App">
      <BrowserRouter>
        <div className="content-wrapper">
          <NavBar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/package" element={<Packages />} />
            <Route path="/about" element={<AboutUs />}></Route>
            <Route path="/contact" element={<ContactUs />}></Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <footer className="footer">
          <div className="container">
            <p>&copy; {currentYear} Yaa Cabs. All rights reserved.</p>
          </div>
        </footer>
      </BrowserRouter>
    </div>
  );
}
export default App;
